import * as moment from 'moment';

export class ClientFilter {
  clientName : string;
  clientId : number;
  mainContact : string;
  mainPhone : string;
  mainEmail : string;
  lastOrderedDateFrom : moment.Moment;
  lastOrderedDateTo : moment.Moment;
  approvedDateFrom : moment.Moment;
  approvedDateTo : moment.Moment;
  isActive : boolean;
}